// extracted by mini-css-extract-plugin
export default {"root":"ContentLayout_root__5cT1M"};